export default __webpack_public_path__ + "static/horizontal-white-d574e0355da69259cbe2fee13655e37f.png";